import moment from "moment/moment";

export default {
	methods: {
		_addEventListeners(calendar) {
			calendar.on('eventDrop', this.onEventChange.bind(this, 'eventDrop'));
			calendar.on('eventResize', this.onEventChange.bind(this, 'eventResize'));
		},

		onEventChange(eventType, event) {
			let data = event.event._def;
			let start = event.event._instance.range.start;
			let end = event.event._instance.range.end;

			let userId = this.userId ?? data.resourceIds[0] ?? null;

			if(!userId) {
				Helpers.Message.error('Er is iets fout gegaan.');
				return;
			}

			this.updateAppointment(data.publicId, {
				name: data.title,
				description: data.extendedProps.description,
				user_id: userId,
				customer_id: data.extendedProps.customer_id,
				start_date: moment.utc(start).format('YYYY-MM-DD HH:mm'),
				end_date: moment.utc(end).format('YYYY-MM-DD HH:mm'),
			}, eventType);
		},

		updateAppointment(id, data, eventType = 'eventDrop') {
			$.ajax({
				url: route('api.v1.appointments.update', {appointment: id}),
				method: 'PUT',
				data: data,
				success: (response) => {
					let message = `Het agenda item ${data.name} is verzet`;
					if (eventType === 'eventResize') {
						message = `Het agenda item ${data.name} is aangepast`;
					}
					Helpers.Message.success(message);
					this.updateCalendar();
				}
			})
		},

		updateCalendar() {
			$(this.$refs.calendar).data('calendar').refetchEvents();
		},
	}
}